import React from 'react';
import DetailRow from 'src/components/DetailRow';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { formatPositiveAmount, formatRate } from 'src/utils/formatAmout';
import { getClientPersonTypePrefix } from 'src/utils/common';
import { Link } from 'react-router-dom';

const GeneralContractDetail = ({ contract }) => {
  const { t } = useTranslation();

  return (
    <>
      <DetailRow
        name={t('COMMON.CLIENT')}
        value={
          <Link to={`/clients/detail/${contract.clientId}`}>
            {getClientPersonTypePrefix({
              personType: contract.clientPersonType
            })}
            {contract.clientName}
          </Link>
        }
      />
      {contract.cededToContractId && (
        <DetailRow
          // While the cession is still open this is the only way to reach the
          // contract it created, so the row is always shown — the label tells
          // the two situations apart instead of hiding one of them.
          name={t(
            contract.outgoingCession
              ? 'CONTRACT_VIEW.CESSION_IN_PROGRESS_TO_CONTRACT'
              : 'CONTRACT_VIEW.CEDED_TO_CONTRACT'
          )}
          value={
            <Link to={`/contracts/${contract.cededToContractId}`}>
              {contract.cededToContractFolio}
            </Link>
          }
        />
      )}
      {contract.previousContractId && (
        <DetailRow
          name={t('CONTRACT_VIEW.ORIGINATED_FROM_CESSION_OF')}
          value={
            <Link to={`/contracts/${contract.previousContractId}`}>
              {contract.previousContractFolio}
            </Link>
          }
        />
      )}
      <DetailRow
        name={t('COMMON.EQUIPMENT')}
        value={
          <Link to={`/inventory/${contract.equipmentId}`}>
            {`${contract.equipmentId} - ${contract.equipmentData.brand} ${contract.equipmentData.model}`}
          </Link>
        }
      />
      <DetailRow
        name={
          contract.isMsiModality
            ? t('CONTRACT_VIEW.IMPLICIT_RATE')
            : t('CONTRACT_VIEW.RATE')
        }
        value={`${formatRate(contract.rate)} %`}
      />
      <DetailRow
        style={{
          display: 'none'
        }}
        name={t('CONTRACT_VIEW.CAT')}
        value={
          contract.cat ? `${formatRate(contract.cat)} %` : t('COMMON.NO_DATA')
        }
      />
      <DetailRow name={t('CONTRACT_VIEW.TERM')} value={`${contract.term}`} />
      <DetailRow
        name={t('CONTRACT_VIEW.EQUIPMENT_COST')}
        value={formatPositiveAmount(contract.equipmentCost)}
      />
      <DetailRow
        name={t('CONTRACT_VIEW.INITIAL_PAYMENT')}
        value={formatPositiveAmount(contract.initialPayment)}
      />
      <DetailRow
        name={t('CONTRACT_VIEW.NET_INVESTMENT')}
        value={formatPositiveAmount(contract.netInvestment)}
      />
      <DetailRow
        name={t('CONTRACT_VIEW.RESIDUAL')}
        value={formatPositiveAmount(contract.residualPayment)}
      />
    </>
  );
};

GeneralContractDetail.propTypes = {
  contract: PropTypes.object.isRequired
};
export default GeneralContractDetail;
